$('#subcontractor').on('change', function(){
    $('#user').parent().toggle(!$(this).is(':checked'));
});
$('#subcontractor').trigger('change'); //Sets visibility of the user select on page load

//Sets the values of other inputs related to the user when it's changed
$('#user').on('change', function(){
    let text = $(this).find('option:selected').text().trim();

    if($(this).val() == ''){
        text = '';
    }

    $('#name').val(text);

    $('#hourly-rate').val($(this).find('option:selected').data('hours'));
    $('#overtime-hourly-rate').val($(this).find('option:selected').data('overtime-hours'));
});


$(`.delete-timesheet-btn`).click(function(e){
    e.preventDefault();

    let idElement = $('[name="timesheet[' + this.dataset.index + '][labour_cost_id]"]');
    let elem = $(this).parents().eq(1);

    if(idElement.length == 0){
        removeLabourCostRow(elem);
    } else {
        axios.delete(`/timesheets/delete/${idElement.val()}`)
            .then(function(){
                removeLabourCostRow(elem);
            });
    }
});

function removeLabourCostRow(element){
    element.prev().prev().remove();
    element.prev().remove();
    element.remove();
}

$('#new-costing').click(function(){
    let index = $('#labour-costs-body').find('tr:last').data('previous-key');
    index++;

    $('#labour-costs-body').append(`
        <tr>
            <td rowspan="2">
                <select class="select2-${index}" name="timesheet[${index}][job_id]"></select>
            </td>
            <td>N/T</td>
            <td><input type="number" step="0.01" min="0" max="24" class="form-control" name="timesheet[${index}][monday_hours]" value="0"></td>
            <td><input type="number" step="0.01" min="0" max="24" class="form-control" name="timesheet[${index}][tuesday_hours]" value="0"></td>
            <td><input type="number" step="0.01" min="0" max="24" class="form-control" name="timesheet[${index}][wednesday_hours]" value="0"></td>
            <td><input type="number" step="0.01" min="0" max="24" class="form-control" name="timesheet[${index}][thursday_hours]" value="0"></td>
            <td><input type="number" step="0.01" min="0" max="24" class="form-control" name="timesheet[${index}][friday_hours]" value="0"></td>
            <td><input type="number" step="0.01" min="0" max="24" class="form-control" name="timesheet[${index}][saturday_hours]" value="0"></td>
            <td><input type="number" step="0.01" min="0" max="24" class="form-control" name="timesheet[${index}][sunday_hours]" value="0"></td>
        </tr>
        <tr>
            <td>O/T</td>
            <td><input type="number" step="0.01" min="0" max="24" class="form-control" name="timesheet[${index}][monday_overtime_hours]" value="0"></td>
            <td><input type="number" step="0.01" min="0" max="24" class="form-control" name="timesheet[${index}][tuesday_overtime_hours]" value="0"></td>
            <td><input type="number" step="0.01" min="0" max="24" class="form-control" name="timesheet[${index}][wednesday_overtime_hours]" value="0"></td>
            <td><input type="number" step="0.01" min="0" max="24" class="form-control" name="timesheet[${index}][thursday_overtime_hours]" value="0"></td>
            <td><input type="number" step="0.01" min="0" max="24" class="form-control" name="timesheet[${index}][friday_overtime_hours]" value="0"></td>
            <td><input type="number" step="0.01" min="0" max="24" class="form-control" name="timesheet[${index}][saturday_overtime_hours]" value="0"></td>
            <td><input type="number" step="0.01" min="0" max="24" class="form-control" name="timesheet[${index}][sunday_overtime_hours]" value="0"></td>
        </tr>
        <tr data-previous-key="${index}">
            <td>Notes</td>
            <td colspan="7">
                <textarea class="form-control" name="timesheet[${index}][notes]"></textarea>
            </td>
            <td colspan="1">
                <button class="btn btn-sm btn-danger delete-timesheet-btn" data-index="${index}">Delete</button>
            </td>
        </tr>
    `);

    var elem = $('.select2-' + index);

    elem.append($('#job_selection').html());
    elem.find('option').removeAttr('data-select2-id');
    elem.select2();


    $(`.delete-timesheet-btn[data-index="${index}"]`).click(function(e){
        if($('timesheet[' + this.dataset.index + '][labour_cost_id]').length == 0){
            e.preventDefault();

            removeLabourCostRow($(this).parents().eq(1));
        }
    });
});
